<template>
  <div class="fh-select-view">
    <span v-if="showLabel" class="title"> <component :is="fieldIconMapping[4]" class="prefix-icon" />请选择视图 </span>
    <jw-select :trigger-props="{ updateAtScroll: true }" v-model="defaultActiveKey" placeholder="请选择视图" class="system-form-item-fields" :options="viewList" allow-search @change="changeView" :field-names="{ value: 'id', label: 'name' }" v-bind="$attrs">
      <template #label="{ data }">
        <div class="select-label">
          {{ data.name }}
        </div>
      </template>
    </jw-select>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { tableService } from '@/api';
import { hyzbOrgId, hyzbOrgViewIds, zhiShuOrgId, zhiShuOrgViewIds } from '@/utils/const';
import { useLayoutStore, useUserStore } from '@/store';
import { useRoute } from 'vue-router';
import useFields from '@/hooks/fields';

const props = defineProps({
  entity: {
    type: [Number, String],
    default: 0
  },
  viewId: {
    type: [Number, String],
    default: 0
  },
  showLabel: {
    type: Boolean,
    default: false
  }
});
const emits = defineEmits(['cb']);
const { userInfo } = useUserStore();
const useLayout = useLayoutStore();
const route = useRoute();
const viewList = ref([]);
const defaultActiveKey = ref('');
const { fieldIconMapping } = useFields();
//获取对象下的视图
const getView = async (params) => {
  viewList.value = [];
  try {
    const res = await tableService.getViewAndGroup(params);
    if (!res?.error) {
      const r = res?.result || [];
      // 判断没有视图的场景
      if (!r.length) {
        emits('cb', { viewId: 0 });
        return;
      }
      viewList.value = r;
      // 这里是学冬让做的 仅针对3租户 智书的 特殊逻辑 s
      if (userInfo?.orgId === zhiShuOrgId) {
        if (props.entity === 2) {
          if (route.path?.indexOf('/customer-sales') > -1) {
            viewList.value = r.filter((el) => zhiShuOrgViewIds.includes(el.id));
          } else {
            viewList.value = r.filter((el) => !zhiShuOrgViewIds.includes(el.id));
          }
        }
      }
      // 这里是学冬让做的 仅针对3租户 智书的 特殊逻辑  e

      // 这里是学冬让做的 仅针对华映385租户 智书的 特殊逻辑 s
      if (userInfo?.orgId === hyzbOrgId) {
        if (props.entity === 1) {
          if (route.path?.indexOf('/hy-leads') > -1) {
            viewList.value = r.filter((el) => hyzbOrgViewIds.includes(el.id));
          } else {
            viewList.value = r.filter((el) => !hyzbOrgViewIds.includes(el.id));
          }
        }
      }
      // 这里是学冬让做的 仅针对华映385租户 智书的 特殊逻辑  e

      let setActiveKey = defaultActiveKey.value;
      if (viewList.value.find((item) => item.id == props.viewId)) {
        setActiveKey = props.viewId;
      } else if (viewList.value.find((item) => item.id == useLayout?.changeViewId?.[props.entity])) {
        setActiveKey = useLayout?.changeViewId?.[props.entity];
      } else {
        setActiveKey = viewList.value[0]?.id;
      }
      defaultActiveKey.value = Number(setActiveKey);

      emits('cb', { viewId: defaultActiveKey.value });
    }
  } catch (e) {
    console.log(e);
  }
};
const changeView = (v) => {
  emits('cb', { viewId: v });
};
onMounted(() => {
  getView({ entity: props.entity });
});
</script>

<style scoped lang="less">
@import './fh-select-view.less';
</style>
